export const messageStatuses = {
  read: 'read',
  sent: 'sent',
  delivered: 'delivered',
  unread: 'unread',
  open: 'open',
  processed: 'processed',
  click: 'click',
  // failure
  dropped: 'dropped',
  bounced: 'bounced',
  undelivered: 'undelivered',
  unsubscribed: 'unsubscribed',
  invalid: 'invalid',
  spammed: 'spammed',
  unknownfailure: 'unknownfailure',
  failedtosend: 'failedtosend',
};

export const messageFailureStatuses = [
  messageStatuses.unsubscribed,
  messageStatuses.invalid,
  messageStatuses.spammed,
  messageStatuses.unknownfailure,
  messageStatuses.bounced,
];

export const messageTypes = {
  text: 'text',
  file: 'file',
  product: 'product',
  collection: 'collection',
  notification: 'notification',
  sms: 'SMS',
  email: 'EMAIL',
  chat: 'CHAT',
  voice: 'VOICE',
  link: 'link',
  dleChat: 'DLE_CHAT',
};

export const messageDirections = {
  inbound: 'Inbound',
  outbound: 'Outbound',
};

export const failureMessageLabels = {
  unsubscribed: 'Unsubscribed',
  invalid: 'Invalid Email',
  spammed: 'Marked as Spam',
  unknownfailure: 'Unknown',
  bounced: 'Invalid Email',
};

export const SHARED_ASSET_LIMIT = 5;
export const SHARED_PRODUCT_LIMIT = 5;
export const MMS_PDF_MB_LIMIT = 0.675;

export const IPHONE_REACTIONS = {
  LIKED: 'Liked',
  DISLIKED: 'Disliked',
  LOVED: 'Loved',
  LAUGHED: 'Laughed at',
  EMPHASIZED: 'Emphasized',
  QUESTIONED: 'Questioned',
};
